var aclh_module_analytics = (function(aclh_module_analytics) {




  function tracking_adobe(name,type,interaction,position){
    // adobe
    //     name: "<Name of the content that has been interacted with, like the name of a button or video>",
    //     type: "<Type of the content, like 'Video' or 'Button'>",
    //     interaction: "<Name of the interaction, like 'Click' or 'Play'>",
    //     position: "<Position of content on the page, especially if the same content appears multiple times, like 'Top', 'Bottom', "First", "Last", etc.>"
    var detailParams = { content:
      {
        'name': name,
        'type': type,
        'interaction': interaction,
        'position': position
      }
    }
    var adobeEvent = new CustomEvent('dhl_utf_contentInteraction', { bubbles: true, detail: detailParams});
    window.dispatchEvent(adobeEvent);
    console.log('Adobe Tracking:',name+', '+type+', '+interaction+', '+position);



  };
  function tracking_decibel(name,type,interaction,position){
    var decibelEvent = new CustomEvent('dhl_utf_trackDecibelEvent', { bubbles: true, detail: {"decibel":{"event":{"name":(name+' - type:'+type+' - interaction:'+interaction+' - position:'+position),"type":"SPA","scope":"Auto-mobility Components - lighthouse"}}}});
    window.dispatchEvent(decibelEvent);
    console.log('Decibel Tracking:',name+', type:'+type+' ,interaction:'+interaction+', position:'+position);
  };



  function tracking_adobe_with_attributes(name,type,interaction,position,attributes){
    var detailParams = { content:
      {
        'name': name,
        'type': type,
        'interaction': interaction,
        'position': position,
        'attributes': attributes,
      }
    }
    var adobeEvent = new CustomEvent('dhl_utf_contentInteraction', { bubbles: true, detail: detailParams});
    window.dispatchEvent(adobeEvent);
    console.log('Adobe Tracking With Attributes:',name+', '+type+', '+interaction+', '+position+', '+attributes);

  };

  function tracking_decibel_with_attributes(name,type,interaction,position,attributes){
    var decibelEvent = new CustomEvent('dhl_utf_trackDecibelEvent', { bubbles: true, detail: {"decibel":{"event":{"name":(name+' - type:'+type+' - interaction:'+interaction+' - position:'+position+' - attributes:'+attributes),"type":"SPA","scope":"Auto-mobility Components - lighthouse"}}}});
    window.dispatchEvent(decibelEvent);
    console.log('Decibel Tracking With Attributes:',name+', type:'+type+' ,interaction:'+interaction+', position:'+position+', attributes:'+attributes);
  };

  // GLOBAL


  // // external links
  // $('#fowtr-wrapper').on('click', 'a[data-ltr6-tracking-external-link]', function(event) {
  //   var name = $(this).attr('data-ltr6-tracking-external-link');
  //   tracking_adobe(name + ' External Link','Link','Click','First');
  //   tracking_decibel(name + ' External Link','Link','Click','First');
  // });


  // // internal links
  // $('#fowtr-wrapper').on('click', 'a[data-ltr6-tracking-internal-link]', function(event) {
  //   var name = $(this).attr('data-ltr6-tracking-internal-link');
  //   tracking_adobe(name + ' Internal Link','Link','Click','First');
  //   tracking_decibel(name + ' Internal Link','Link','Click','First');
  // });



  // aclh_module_analytics.currentSectionInView = 0;

  aclh_module_analytics.init = function() {
    // aclh_module_analytics.currentChapter = chapter;
    // if(typeof window.ltr6_trend_name !== 'undefined') {
    //   var trend = window.ltr6_trend_name;
    //   console.log('dataLayer.page.pageInfo.pageName','Auto-mobility Components - lighthouse | '+trend+' | DHL');
    //   try {
    //     dataLayer.page.pageInfo.pageName = 'Auto-mobility Components - lighthouse | '+trend+' | DHL';
    //   } catch(e) {
    //     console.warn('Tracking dataLayer not found');
    //   }
    // } else {
    //   // console.warn('Trend name not found');
    //   dataLayer.page.pageInfo.pageName = 'Auto-mobility Components - lighthouse | '+trend+' | DHL';
    // }





    // if(typeof window.ltr6_dataLayer !== 'undefined') {
    //   // var trend = window.ltr6_trend_name;
    //   console.log('ltr6_dataLayer',window.ltr6_dataLayer);
    //   try {
    //     dataLayer.page.pageInfo.pageName = window.ltr6_dataLayer;
    //   } catch(e) {
    //     console.warn('AEM dataLayer not found');
    //   }
    // } else {
    //   console.warn('ltr6_dataLayer not found');
    // }

    // // page view
    // var event = new CustomEvent('dhl_utf_pageload', { bubbles: true });
    // window.dispatchEvent(event);
    // console.log('dhl_utf_pageload event triggered');




    $('#aclh-wrapper').on('click auxclick', '[data-aclh-tracking]', function(event) {
      var data = $(this).attr('data-aclh-tracking');
      // data = "{'name':'name','type':'type','interaction':'interaction','position':'position','adobe':'true','decibel':'true'}";
      data = data.replace(/'/g, '"');
      data = data.replace(/'\r|\n/, '');
      data = JSON.parse(data);
      // console.log('tracking',data.name);
      if(data.adobe=='true') tracking_adobe(data.name, data.type, data.interaction, data.position);
      if(data.decibel=='true') tracking_decibel(data.name, data.type, data.interaction, data.position);
    });



    // ============================================================================
    // scroll percent tracking
    // ============================================================================
    
    // var highestScrollPercent = 0;
    // var pc25 = false;
    // var pc50 = false;
    // var pc75 = false;
    // var pc100 = false;

    // var scrollTracking = ltr6_module_utilities.debounce(function() {
    //     var s = $(window).scrollTop(),
    //         d = $(document).height(),
    //         c = $(window).height();
    //         f = $('#wcag-footer').height();
    //     var scrollPercent = (s / (d - c - f)) * 100;
    //     if(scrollPercent > highestScrollPercent){
    //       highestScrollPercent = scrollPercent;
    //       if(highestScrollPercent >= 100 && pc100==false) {
    //         tracking_adobe('Percent Scrolled','View','Milestone 100%','Page Scroll');
    //         tracking_decibel('Percent Scrolled','View','Milestone 100%','Page Scroll');
    //         pc100 = true;
    //         return false;
    //       }
    //       if(highestScrollPercent >= 75 && pc75==false) {
    //         tracking_adobe('Percent Scrolled','View','Milestone 75%','Page Scroll');
    //         tracking_decibel('Percent Scrolled','View','Milestone 75%','Page Scroll');
    //         pc75 = true;
    //         return false;
    //       }
    //       if(highestScrollPercent >= 50 && pc50==false) {
    //         tracking_adobe('Percent Scrolled','View','Milestone 50%','Page Scroll');
    //         tracking_decibel('Percent Scrolled','View','Milestone 50%','Page Scroll');
    //         pc50 = true;
    //         return false;
    //       }
    //       if(highestScrollPercent >= 25 && pc25==false) {
    //         tracking_adobe('Percent Scrolled','View','Milestone 25%','Page Scroll');
    //         tracking_decibel('Percent Scrolled','View','Milestone 25%','Page Scroll');
    //         pc25 = true;
    //         return false;
    //       }
    //     }
    //     // console.log('scrollPercent',scrollPercent);
    // }, 500);
    // window.addEventListener('scroll', scrollTracking);




    // // guided tour
    // $('#ltr6-wrapper').on('click', '.ltr6-tutorial-link', function(event) {
    //   event.preventDefault();
    //   aclh_module_analytics.tracking_adobe('Guided Tour','Button','Click','First');
    //   aclh_module_analytics.tracking_decibel('Guided Tour','Button','Click','First');
    // });


 

  }; //end init


  // expose externally
  aclh_module_analytics.tracking_adobe = function(name,type,interaction,position){
    tracking_adobe(name,type,interaction,position);
  };
  aclh_module_analytics.tracking_adobe_with_attributes = function(name,type,interaction,position,attributes){
    tracking_adobe_with_attributes(name,type,interaction,position,attributes);
  };
  aclh_module_analytics.tracking_decibel = function(name,type,interaction,position){
    tracking_decibel(name,type,interaction,position);
  };
  aclh_module_analytics.tracking_decibel_with_attributes = function(name,type,interaction,position,attributes){
    tracking_decibel_with_attributes(name,type,interaction,position,attributes);
  };


  aclh_module_analytics.destroy = function(trend){
    // console.log('destroy chapter analytics '+trend);
  };//end destroy function


  return aclh_module_analytics;
}(aclh_module_analytics || {}));